"use strict";import{tag as r}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const FolderOutlineIcon=({width:e=24,height:t=24,hidden:l=!1,title:a="Folder Outline"}={})=>r`<svg
    xmlns="http://www.w3.org/2000/svg"
    height=${t}
    viewBox="0 0 36 36"
    width=${e}
    aria-hidden=${l?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label=${a}
  >
    <path
      d="m33 8-14.331.008-3.3-3.4A2 2 0 0 0 13.929 4H4a2 2 0 0 0-2 2v23a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm-1 20H4V10h28Z"
    />
  </svg>`;
//# sourceMappingURL=FolderOutline.js.map
